export default __webpack_public_path__ + "static/open-letter-40d93f0546f60d28c58dfbdd3b99c900.png";